import { AttributeSerializedValue, ConfiguredProductOptions, ExpiviAttributeValueModel, ExpiviSaveConfigResult } from "app/shared/models/expivi.models";
import { ConfiguratorStateDto, ConfigurationDTO, ConfiguratorStateAttributeDto, AttributeValueDTO, AttributeValueOperandDTO, ConfiguratorJsonStateLight } from "../models/customization-request.models";
import { UtilityFunctions } from "./functions.models";
import { EXPIVI_CATALOG_IDS_TO_EXCLUDE, EXPIVI_DEFAULT_CONFIG_STATE } from "app/shop/shared/constants/shared.constants";
import { CustomizationRequestStatusEnum, CustomizationRequestStatusVMEnum } from "../enums/customization-request-status.enum";

export class ExpiviMapper {

  public static MapCustomCRStatusInverse(statusVM: CustomizationRequestStatusVMEnum): { status: CustomizationRequestStatusEnum; notifiedByUser: boolean } {
    switch (statusVM) {
      case CustomizationRequestStatusVMEnum.DraftWithNotification:
        return {
          status: CustomizationRequestStatusEnum.Draft,
          notifiedByUser: true
        };
  
      case CustomizationRequestStatusVMEnum.DraftWithoutNotification:
        return {
          status: CustomizationRequestStatusEnum.Draft,
          notifiedByUser: false
        };
  
      case CustomizationRequestStatusVMEnum.ApprovedByRequestingUser:
        return {
          status: CustomizationRequestStatusEnum.ApprovedByRequestingUser,
          notifiedByUser: null
        };
  
      case CustomizationRequestStatusVMEnum.CommerciallyApproved:
        return {
          status: CustomizationRequestStatusEnum.CommerciallyApproved,
          notifiedByUser: null
        };
  
      case CustomizationRequestStatusVMEnum.GraphicallyApproved:
        return {
          status: CustomizationRequestStatusEnum.GraphicallyApproved,
          notifiedByUser: null
        };
  
      case CustomizationRequestStatusVMEnum.Rejected:
        return {
          status: CustomizationRequestStatusEnum.Rejected,
          notifiedByUser: null
        };

      case CustomizationRequestStatusVMEnum.Ordered:
        return {
          status: CustomizationRequestStatusEnum.Ordered,
          notifiedByUser: null
        };

      default:
        return {
          status: null,
          notifiedByUser: null
        };
    }
  }
  
  public static MapCustomCRStatus(status: CustomizationRequestStatusEnum, notifiedByUser: boolean): CustomizationRequestStatusVMEnum {
    switch (status) {
      case CustomizationRequestStatusEnum.Draft:
        return notifiedByUser ? CustomizationRequestStatusVMEnum.DraftWithNotification : CustomizationRequestStatusVMEnum.DraftWithoutNotification;
      case CustomizationRequestStatusEnum.ApprovedByRequestingUser:
        return CustomizationRequestStatusVMEnum.ApprovedByRequestingUser;
      case CustomizationRequestStatusEnum.CommerciallyApproved:
        return CustomizationRequestStatusVMEnum.CommerciallyApproved;
      case CustomizationRequestStatusEnum.GraphicallyApproved:
        return CustomizationRequestStatusVMEnum.GraphicallyApproved;
      case CustomizationRequestStatusEnum.Rejected:
        return CustomizationRequestStatusVMEnum.Rejected;
      case CustomizationRequestStatusEnum.Ordered:
        return CustomizationRequestStatusVMEnum.Ordered;
      default:
        return null;
    }
  }

  public static ExpiviConfigurationToFourShopConfiguration(configurationProduct: ConfiguredProductOptions) {

    return new ConfiguratorStateDto({
      version: configurationProduct.version,
      configuration: new ConfigurationDTO({
        attributes: configurationProduct.configuration.attributes.map(x => new ConfiguratorStateAttributeDto({
          id: x.attribute_id,
          name: x.attribute_name,
          value: UtilityFunctions.removeNullsFromObj(new AttributeValueDTO({
            imageSource: x.attribute_value.image_source,
            offset: x.attribute_value.offset,
            ratio: x.attribute_value.ratio,
            repeatType: x.attribute_value.repeat_type,
            rotation: x.attribute_value.rotation,
            scale: x.attribute_value.scale,
            size: x.attribute_value.size,
            value: x.attribute_value.value,
            calculatedValue: x.attribute_value.calculated_value,
            operands: x.attribute_value.operands?.map(y => new AttributeValueOperandDTO({
              step: y.step,
              value: y.value,
            })),
            output: x.attribute_value.output,
            valueId: x.attribute_value.attribute_value_id,
          })),
          valueName: x.attribute_value_name || '',
        }))
      }),
    });
  }


  public static FourShopConfigurationToExpiviConfiguration(configurationProduct: ConfiguratorStateDto) {
    if (configurationProduct) {
      return new ExpiviSaveConfigResult({
        configured_products: [
          new ConfiguredProductOptions({
            version: configurationProduct.version,
            configuration: {
              attributes: configurationProduct.configuration.attributes.map(x => new AttributeSerializedValue({
                attribute_id: x.id,
                attribute_name: x.name,
                attribute_value_name: x.valueName,
                attribute_value: UtilityFunctions.removeNullsFromObj(new ExpiviAttributeValueModel({
                  image_source: x.value.imageSource,
                  offset: x.value.offset,
                  ratio: x.value.ratio,
                  repeat_type: x.value.repeatType,
                  rotation: x.value.rotation,
                  scale: x.value.scale,
                  size: x.value.size,
                  value: x.value.value,
                  attribute_value_id: x.value.valueId,
                  calculated_value: x.value.calculatedValue,
                  operands: x.value.operands,
                  output: x.value.output,
                })),
              }))
            }
          })
        ]
      });
    } else { return null; }
  }


  public static ElaborateConfigurationProduct(catalogueId: number, configurationProduct: ConfiguredProductOptions): ConfiguredProductOptions {
    return EXPIVI_CATALOG_IDS_TO_EXCLUDE?.some(x => catalogueId && x === catalogueId) ? JSON.parse(EXPIVI_DEFAULT_CONFIG_STATE) : configurationProduct;
  }

  public static ExpiviConfigurationStateLight(configurationProduct: ConfiguredProductOptions) {
    return new ConfiguratorJsonStateLight({
      configured_products: [
        {
          version: configurationProduct.version,
          configuration: {
            attributes: configurationProduct.configuration.attributes,
          },
        }
      ]
    });
  }





}
